import './themeDefaults';
import TYPES from './types';

export default ({ modal, zIndex }) => ({
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 }
  },
  '@keyframes genie': {
    from: {
      opacity: 0,
      transform: 'scale(0.8) translate(-50%, -50%)'
    },
    to: {
      opacity: 1,
      transform: 'scale(1) translate(-50%, -50%)'
    }
  },

  transparentOverlay: {
    animationName: '$fadeIn',
    animationDuration: '.1s',
    position: 'fixed',
    zIndex: 9999,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'transparent',
    pointerEvents: 'none'
  },

  overlay: {
    '&$overlayScreen': {
      background: modal.backgroundOverlay,
      pointerEvents: 'auto'
    },
    animationName: '$fadeIn',
    animationDuration: '.1s',
    position: 'fixed',
    zIndex: 9999,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'transparent',
    pointerEvents: 'none'
  },
  overlayScreen: {},
  dynamic: {},
  hasType: {},
  hasNoHeader: {},
  card: {
    '&$dynamic': {
      animationName: '$fadeIn',
      transform: 'none',
      top: ({ posY }) => posY,
      left: ({ posX }) => posX
    },
    animationName: '$genie',
    animationDuration: '.5s',
    animationTimingFunction: 'ease-in-out',
    transformOrigin: '0px 0px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: zIndex.modal,
    width: ({ width }) => width,
    minWidth: ({ minWidth }) => minWidth,
    minHeight: ({ minHeight }) => minHeight,
    maxWidth: '100vw',
    ...modal.cardDropShadow,
    background: modal.backgroundCard,
    borderRadius: modal.borderRadius,
    boxSizing: 'border-box',
    overflow: 'hidden',
    pointerEvents: 'all',
    ...modal.card
  },
  takeover: {
    animationName: '$fadeIn',
    animationDuration: '.5s',
    zIndex: zIndex.modal,
    background: modal.backgroundCard,
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    ...modal.takeover
  },
  contentHasOverflow: {},
  content: {
    '&$contentHasOverflow': {
      overflowY: 'auto'
    },
    '&$hasNoHeader': {
      padding: modal.content.noHeaderPadding
    },
    ...modal.content
  },
  [TYPES.ERROR]: {
    ...modal.errorModal
  },
  [TYPES.WARNING]: {
    ...modal.warningModal
  },
  [TYPES.SUCCESS]: {
    ...modal.successModal
  },
  [TYPES.INFO]: {
    ...modal.infoModal
  },
  actions: {
    marginTop: 30,
    marginBottom: -24,
    '& button': {
      marginRight: 15,
      marginBottom: 24
    },
    ...modal.actions
  }
});
